import utilRouter from "@/libs/util.router.js";
const config = {
  navMenuConfig: {
    title: "北京信息科技大学马克思主义学院数字马院",
    menuBackgroundColor: "#a52a2a",//菜单栏颜色
    menuTextColor: "#fff",
    menuActiveTextColor: "#fff",
  },
  relationId: "9392",
  menuList: [
    {
      title: "首页",
      type: 1,
      content: "/bjkj/portal",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },{
      title: "实践项目",
      type: 2,
      content: "https://bistu.ulearning.cn/sjjx/web/index.html#/main/sjjxProject/203/1/1824",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },{
      title: "资源库",
      type: 1,
      content: "",
      isActive: utilRouter.noop,
      subMenuList: [
       {
          title: "思政教学备课资源库",
          type: 2,
          content: "https://marx.ulearning.cn/digitalweb/prepareResource.do",
          subMenuList: [],
          isActive: utilRouter.isPathActive
        },{
          title: "高校思想政治教育辅助教学资源库",
          type: 2,
          content: "https://marx.ulearning.cn/digitalweb/getCourseList.do",
          subMenuList: [],
          isActive: utilRouter.isPathActive
        },{
          title: "中国共产党思想理论资源数据库",
          type: 2,
          content: "http://data.lilun.cn/index_custom.html",
          subMenuList: [],
          isActive: utilRouter.isPathActive
        },{
          title: "习近平系列重要讲话数据库",
          type: 2,
          content: "http://jhsjk.people.cn/",
          subMenuList: [],
          isActive: utilRouter.isPathActive
        }
      ],
    },{
      title: "微课",
      type: 1,
      content: "/bjkj/news/2012?type=3",
      isActive: isNewsActive({menuId:2012,type:3}),
      subMenuList: [],
    },{
      title: "VR展馆",
      type: 1,
      content: "/bjkj/redResources",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },
    {
      title: "学院首页",
      type:2,
      content: "https://cpe.bistu.edu.cn/",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    }
  ],
  menus: [{
    id: 1,
    title: "通知新闻",
    type: 1,
    menuId: 1723
  }, {
    id: 2,
    title: "政策文件",
    type: 2,
    menuId: 1724
  }, {
    id: 3,
    title: "数字红馆",
    type: 2,
    menuId: 1725
  }],
  breadConfig: {
    Icon: "",
    firstBreTitle: "首页",
    separator: ">",
    breadTitle: "文章详情",
  },
};
function isNewsActive(params) {
  var rules = [
    {
      path: "/bjkj/news/:menuId",
      params: {
        menuId:params.menuId,
      },
      query:{
        type:params.type,
      }
    },
    {
      path: "/bjkj/brandContent/:id",
      params: {
        menuId:params.id,
      }
    }
  ];

  return function(route) {
    return utilRouter.isMatch(route, rules);
  };
}
// function isNewsActive(id) {
//   var rules = [
//     {
//       path: "/tjxd/news/:menuId",
//       params: {
//         menuId: id,
//       },
//     },
//     {
//       path: "/tjxd/newsContent/:id",
//     },
//   ];

//   return function(route) {
//     return utilRouter.isMatch(route, rules);
//   };
// }
// function isCourseActive() {
//   var rules = [
//     {
//       path: "/tjxd/courseContent/:id",
//     },
//     {
//       path: "/tjxd/courses",
//     },
//   ];

//   return function(route) {
//     return utilRouter.isMatch(route, rules);
//   };
// }
// function isTeachersActive() {
//   var rules = [{
//     path: "/tjxd/teachers",
//   }, {
//     path: "/tjxd/teacherContent/:id",
//   }];

//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isCourseActive(id) {
//   var rules = [{
//     path: "/tjxd/courses/:id",
//     params: {
//       id: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isElaborateActive(id) {
//   var rules = [{
//     path: "/tjxd/elaborate/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isSchoolLevelActive(id) {
//   var rules = [{
//     path: "/tjxd/schoolLevel/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }

export default config;
